import { convertArrayToIndexedGetParam } from 'Util/FetchUtils';
import axios from 'axios';
import {
	ICourseOfferingEntityAttributes,
	IRequirementEntityAttributes,
	ICampusEntityAttributes,
	ICourseLevelEntityAttributes,
	IDisciplineEntityAttributes,
	IFacultyEntityAttributes,
	ISchoolEntityAttributes,
	ITermEntityAttributes,
} from 'Models/Entities';

export const getCourseOfferingsForRequirements = async (
	requirementIds: Array<string>,
) => {
	if (requirementIds.length === 0) {
		return undefined;
	}

	const urlRequirementIds = convertArrayToIndexedGetParam('requirementIds', requirementIds);

	const response = await axios
		.get<{
			courseOfferings: ICourseOfferingEntityAttributes[]
			requirements: IRequirementEntityAttributes[]
			availableCourseFilters: {
				levels: ICourseLevelEntityAttributes[],
				terms: ITermEntityAttributes[],
				faculties: IFacultyEntityAttributes[],
				schools: ISchoolEntityAttributes[],
				disciplines: IDisciplineEntityAttributes[],
				locations: ICampusEntityAttributes[],
			}
		}>(
			`/api/entity/CourseEntity/requirement-offerings?${urlRequirementIds}`,
		)
		.catch(err => {
			console.error(err);
		});

	return response
		? response.data
		: undefined;
};

export const removeCourseOfferings = async (
	courseOfferingIds: Array<string>,
) => {
	return axios
		.delete<{
			courseOfferingIds: string[]
		}>('/api/entity/CourseOfferingEntity/remove-course-offerings', {
			data: {
				courseOfferingIds,
			},
		});
};
